import React from "react";

// Components
import { Header } from './LoyaltyHeader.style';


export const LoyaltyHeader = () => {
    return (
        <Header>
            <span>
                Fidelidade e cartelas do usuário
            </span>
        </Header>
    )
}